// Dependencies imports
import React, { useState } from 'react';
import { DataGrid, GridToolbarContainer, GridToolbarExport, GridToolbar } from '@material-ui/data-grid';
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from '@material-ui/styles';
import moment from "moment";

// Local imports
import config from "../../../config/aws-exports";

// Style imports
import Course from './CourseView.module.scss';

// let columns = [];
function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ display: "flex", justifyContent: "flex-end" }}>
        <GridToolbar />
      </GridToolbarContainer>
    );
  }


  const useStyles = makeStyles({
    root: {
      '& .super-app-theme--header': {
        backgroundColor: config.main_color_1,
        fontSize: "16px",
        color: 'rgb(255,255,255)',
        fontFamily: "nunito"
      },
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
    },
    ".MuiDataGrid-root": {
      fontSize: "14px",
      fontFamily: "nunito",
      fontWeight: 400,
      color: "black",
      cursor: "pointer"
    }
  });


  const tcolumns = [
    { field: 'col1', headerName: 'Sl.No', headerClassName: 'super-app-theme--header', width: 150},
    { field: 'col2', headerName: 'Live Session name', flex: 1, headerClassName: 'super-app-theme--header' },
    { field: 'col3', headerName: 'Session Date', flex: 1, headerClassName: 'super-app-theme--header' },
    { field: 'col4', headerName: 'No.of users attended', flex: 1, headerClassName: 'super-app-theme--header' },
  ];

const BatchLevel = (props) => {
    let { courseView, loading } = props;
    console.log("courseview inside batch level", courseView);
    const classes = useStyles();
    let trows = [];
    let batchArray = courseView === undefined ? [] : courseView["batch"];
    console.log("batch array", batchArray);
    if (courseView === undefined || batchArray === undefined){
        trows = [
            {id: "1",col1: "", col2: "No Sessions", col3: " "}
        ];

    }else{
    
    for (let i=0; i < batchArray.length ; i++){
        console.log("courseView.batch[i]", batchArray[i]["title"]);
        let obj = {};
        obj.id = i;
        obj.col1 = i+1;
        obj.col2 = batchArray[i]["title"];
        let timeinDate = batchArray[i]["start"];
        obj.col3 = moment(timeinDate).format("DD-MM-YYYY");
        obj.col4 = batchArray[i]["count"];
        trows.push(obj);
    }
    console.log("trows",trows);

    }
    

    return(
        <>
        <div style={{ height: 300, width: '100%' }} className={classes.root}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", paddingBottom: "20px"}}>
        <h4 className={Course.taken}>{batchArray.length} Live sessions taken</h4>
        </div>
        {loading === false ?
          <DataGrid rows={trows} columns={tcolumns}  className={classes['.MuiDataGrid-root']}
            components={{
              Toolbar: CustomToolbar,
            }}
            disableSelectionOnClick
          /> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><Skeleton variant="rect" width="100%" height={300} /> </div>}
          
      </div>
       <div style={{height: "100px"}}></div>
       </>
    );
};

export default BatchLevel;